/* eslint-disable no-loop-func */

export function WorkingHours(data, teamMembers, threshold) {
  const userData = data.map((el) => (el?.success ? el.data : null));
  const dataToSend = [];
  const works = [];
  const thresholdNum = Number(threshold) || 0;

  userData.forEach((element, i) => {
    if (element === null) {
      dataToSend.push('-');
      works.push('-');
    } else {
      const work = teamMembers.filter((m) => {
        const entry = element[m.userUID];
        if (!entry || entry.present !== true) return false;
        const productive = entry.totalProductiveTime ?? 0;
        return productive < thresholdNum;
      });
      works[i] = work;
      dataToSend.push(work.length);
    }
  });

  return {
    dataToShow: dataToSend,
    workMembers: works,
  };
}
